import React from 'react'
import ReactDOM from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import App from './App.tsx'
import './index.css'
import './styles/globals.css'
import './styles/mobile-overrides.css'

// Desabilitar console em produção
if (import.meta.env.PROD) {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
  console.warn = () => {}
  console.info = () => {}

  // Desabilitar teclas de atalho comuns do DevTools
  document.addEventListener('keydown', (e) => {
    if (
      // Chrome/Firefox DevTools
      (e.key === 'F12') ||
      // Chrome DevTools
      (e.ctrlKey && e.shiftKey && e.key === 'I') ||
      // Firefox DevTools
      (e.ctrlKey && e.shiftKey && e.key === 'C') ||
      // Chrome/Firefox View Source
      (e.ctrlKey && e.key === 'U')
    ) {
      e.preventDefault()
    }
  })

  // Desabilitar clique direito
  document.addEventListener('contextmenu', (e) => e.preventDefault())

  // Detectar quando DevTools é aberto
  const devtools = {
    isOpened: false,
    toString: function() {
      this.isOpened = true
      return ''
    }
  }
  
  console.log('%c', devtools)
  setInterval(() => {
    const wasOpened = devtools.isOpened
    devtools.isOpened = false
    if (wasOpened) {
      window.location.reload()
    }
  }, 1000)
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>,
) 